export default __webpack_public_path__ + "static/media/4.1d2f4f09.svg";